import { useGetStatementEditor } from './useGetStatementEditor'
import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { StatementEditorContentV6 } from './StatementEditorContentV6'
import { TileFilter } from '../shared/TileFilter'
import { isUISchema } from './types-v6'
import { StatementEditorEmptyResponse } from './StatementEditorEmptyResponse'

export function StatementEditorComponent({ id }: { id: string }) {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetStatementEditor(id, tileFilterSelections)

  if (!isUISchema(data.uiSchema)) {
    return <StatementEditorEmptyResponse />
  }

  return <StatementEditorContentV6 data={data} tileFilters={<TileFilter schema={data.filters} />} />
}
